import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact"
import { useState } from "preact/hooks"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`ns-act-btn ns-filters ns-d-inline-flex ns-text-align-center ns-align-items-center ${className}`}
        >
            {/* <Icon name="filter" /> */}
            <div href="#" class="">
            &nbsp;FILTER&nbsp;
            <span class="md-hide">BY</span>
            <span class="js-filter-count">
            </span>
            +
            </div>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-black ns-ml-1">
                    ({selectedFiltersCount})
                </span>
            )}
        </label>
    )
}

export default function Toolbar({ onViewChange }) {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const [activeView, setActiveView] = useState({
        desktop: 'four-column',
        mobile: 'two-column'    
    })


    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const handleViewChange = (viewType, device) => {
        const newActiveView = {
            ...activeView,
            [device]: viewType
        }
        setActiveView(newActiveView)
        
        if (onViewChange) {
            onViewChange(newActiveView)
        }
    }

    const handlePictureChange = (type, event) => {
        event.preventDefault();
        document.querySelectorAll(".ns-serp .collection-product-grid__categories a").forEach(el => el.classList.remove("active"));
        event.target.classList.add("active");
        document.body.classList.remove("product-grid--images-normal", "product-grid--images-clearcut");
        console.log("TYPE IS", type);
        if(type == "normal") document.body.classList.add("product-grid--images-normal");
        if(type == "clearcut") document.body.classList.add("product-grid--images-clearcut");
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))


    return (
        <>
        {pageType == "search" && <div class="search-results-page__header">
        <h2>Search Results</h2>
        <h5>{response?.products?.total} styles for '{query.query}'</h5>
        </div>}
        <div
            class="ns-header-controls ns-d-flex ns-flex-column ns-flex-md-row ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-w-100 ns-mb-4 ns-flex-row">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
                <ul class="collection-product-grid__categories">
                    <li>
                        <a data-image-type="normal" href="#" class="active" onClick={(e)=> handlePictureChange("normal", e)}>Lookbook</a>
                    </li>
                    <li>
                        <a data-image-type="clearcut" href="#" onClick={(e)=> handlePictureChange("clearcut", e)}>Product</a>
                    </li>
                </ul>
                <div class="view-buttons collection-view-buttons">
                <button 
                        type="button" 
                        className={`view-buttons__four-col-grid desktop ${activeView.desktop === 'four-column' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            handleViewChange('four-column', 'desktop');
                        }}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    <button 
                        type="button" 
                        className={`view-buttons__three-col-grid desktop ${activeView.desktop === 'three-column' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            handleViewChange('three-column', 'desktop');
                        }}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    <button 
                        type="button" 
                        className={`view-buttons__one-col-grid mobile ${activeView.mobile === 'one-column' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            handleViewChange('one-column', 'mobile');
                        }}
                    >
                        <span></span>
                    </button>
                    <button 
                        type="button" 
                        className={`view-buttons__two-col-grid mobile ${activeView.mobile === 'two-column' ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            handleViewChange('two-column', 'mobile');
                        }}
                    >
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
        </div>
        </>
    )
}
